import { useEffect, useState } from "react";
// import { CartList } from "../components/CartList";
// import { ProductDeal } from "../components/ProductDeal";
import { ProductList } from "../components/ProductList";

const ShopPage = () => {
  const [products, setProducts] = useState([]);
  // const [deals, setDeals] = useState([]);
  const [cart, setCart] = useState(0);
  console.log(cart);
  const addToCart = (data: {
    id: number;
    title: string;
    price: number;
    image: string;
    description: string;
  }) => {
    console.log(data);
  };

  // get data from face stpre api
  useEffect(() => {
    fetch("https://fakestoreapi.com/products?limit=10")
      .then((res) => res.json())
      .then((data) => setProducts(data));

    // fetch("https://fakestoreapi.com/products?limit=4")
    //   .then((res) => res.json())
    //   .then((data) => setDeals(data));

    document.title = "Shop";
  }, []);

  return (
    <div className="container mx-auto mt-[64px]">
      <div className="mb-16">
        <div className="bg-white px-5 py-4 mb-4">
          <div className="mb-4">
            <h2 className="font-bold text-lg">Find your Style</h2>
            <h3 className="font-normal text-gray-500">Super Summer Sale</h3>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-2">
            <ProductList products={products} />
          </div>
        </div>

        {/* <div className="bg-white px-5 py-4">
          <div className="mb-3 flex content-between">
            <h2 className="font-semibold">Deals of the Day</h2>
            <a className="ml-auto text-red-500" href="/">
              See All
            </a>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-2 mb-4">
            <ProductDeal products={deals} />
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default ShopPage;
